import { createSlice } from '@reduxjs/toolkit';
import {
  createSupplierJobsExtraReducer,
  getSupplierJobsExtraReducer,
  updateSupplierJobExtraReducer,
  getSupplierJobExtraReducer,
  recursiveGetSupplierJobsExtraReducer,
  bulkUpdateSupplierJobExtraReducer,
  supplierJobInfoSheetRequestExtraReducer,
  updateArchiveStateSupplierJobExtraReducer,
  mergeSupplierJobsExtraReducer,
} from '../reducers/supplierJobsReducers';
import { SupplierJobApiResponse } from '@dill/dill-shared';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface SupplierJobsInitialState {
  loadingList: string[];
  loadingErrorList: object[];
  selectedSupplierJob: SupplierJobApiResponse | null;
  supplierJobsMap: {
    [x: string]: SupplierJobApiResponse;
  };
  supplierJobsNoInvoicesMap: {
    [x: string]: SupplierJobApiResponse;
  };
  supplierJobsArchivedMap: {
    [x: string]: SupplierJobApiResponse;
  };
  selectedSupplierJobs: SupplierJobApiResponse[];
  // Supplier the jobs maps currently belong to. Used to drop late/stale jobs fetch
  // responses from a previously selected supplier (see supplierJobsReducers).
  jobsSupplierId: string | null;
}

const initialState: SupplierJobsInitialState = {
  loadingList: [],
  loadingErrorList: [],
  selectedSupplierJob: null,
  supplierJobsMap: {},
  supplierJobsArchivedMap: {},
  supplierJobsNoInvoicesMap: {},
  selectedSupplierJobs: [],
  jobsSupplierId: null,
};

export const supplierJobsSlice = createSlice({
  name: 'supplierJobs',
  initialState,
  reducers: {
    resetSupplierJobsRootState: () => initialState,
    selectSupplierJobs: (state, action: PayloadAction<any[]>) => {
      const ii = [...state.selectedSupplierJobs.map((iu) => ({ ...iu }))];
      const filteredSupplierJobs = ii.filter(
        (supplierJob) => !action.payload.map((yy: any) => yy.id).includes(supplierJob.id)
      );
      state.selectedSupplierJobs = [...filteredSupplierJobs, ...action.payload];
    },
    unSelectSupplierJobs: (state, action: PayloadAction<any[]>) => {
      const filteredSupplierJobs = state.selectedSupplierJobs.filter(
        (supplierJob) => !action.payload.map((yy: any) => yy.id).includes(supplierJob.id)
      );
      state.selectedSupplierJobs = [...filteredSupplierJobs];
    },
    resetSupplierJobs: (state) => {
      state.selectedSupplierJobs = [];
      state.supplierJobsMap = {};
      state.jobsSupplierId = null;
    },
    resetSelectedSupplierJobs: (state) => {
      state.selectedSupplierJobs = [];
    },
  },
  extraReducers(builder) {
    createSupplierJobsExtraReducer(builder);
    getSupplierJobsExtraReducer(builder);
    updateSupplierJobExtraReducer(builder);
    getSupplierJobExtraReducer(builder);
    recursiveGetSupplierJobsExtraReducer(builder);
    bulkUpdateSupplierJobExtraReducer(builder);
    updateArchiveStateSupplierJobExtraReducer(builder);
    supplierJobInfoSheetRequestExtraReducer(builder);
    mergeSupplierJobsExtraReducer(builder);
  },
});

export const {
  resetSupplierJobsRootState,
  selectSupplierJobs,
  unSelectSupplierJobs,
  resetSupplierJobs,
  resetSelectedSupplierJobs,
} = supplierJobsSlice.actions;
